import { getObjectId, type CompanyEntity } from '@ots-frontend/ots-data';
import { RrcCompanyProfilesPage } from '@ots-frontend/ots-ui-tw';
import type { CardProps } from '../Card/Card';
export type RrcCompanyProfileDataTableCardProps = CardProps & {
  company: CompanyEntity | string;
};
/** Company profiles and standalone compliance management use the same Tailwind manager. */
export const RrcCompanyProfileDataTableCard = ({
  company,
  className,
  style,
}: RrcCompanyProfileDataTableCardProps) => (
  <div className={className} style={style}>
    <RrcCompanyProfilesPage
      companyId={getObjectId(company)}
      companyName={
        typeof company === 'string' ? undefined : company.displayName
      }
      embedded
    />
  </div>
);
